import { Possibility, Availabilities, AvailabilityProvider } from './availability-provider';
import { readable, writable } from 'svelte/store';
export class NoopAvailabilityProvider {
    constructor() {
        this.loading = writable(false);
    }
    load(from, to) {
        return readable(new NoopAvailabilities(), set => { });
    }
}
export class NoopAvailabilities extends Availabilities {
    get showLabel() { return false; }
    isArrivalPossible(date) {
        return Possibility.Possible;
    }
    isDiparturePossible(from, to) {
        return Possibility.Possible;
    }
}
